import React, { useMemo, useState, useCallback } from 'react';
// import { useSignals } from '@preact/signals-react/runtime';
import jsonData from '../../signals/jsonData';
import appState from '../../signals/appState';
import { exhibitorKeyOf } from '../../tools/boothExhibitors';
import useData from '../../hooks/useData';
import translation from '../../signals/translations';
import IconClose from '../../icons/IconClose';
import IconHeart from '../../icons/IconHeart';
import IconHeartFilled from '../../icons/IconHeartFilled';
import useRecord from '../../hooks/useRecord';

const MyFavourites = () => {
	// useSignals();

	const { exhibitorInfo } = jsonData.value;
	const { MyFavourites } = appState.value;
	const { toggleFavourite } = useData();
	const [searchTerm, setSearchTerm] = useState('');
	const { makeRecord } = useRecord();

	const closePanel = () => {
		appState.value = {
			...appState.value,
			ExhibitorList: false,
			MyFavourites: false,
			SearchPanel: false,
		};
	}

	const onlyFavourites = useMemo(() => {
		return exhibitorInfo.filter((exhibitor) => exhibitor.favourite);
	}, [exhibitorInfo]);

	const filteredExhibitorInfo = useMemo(() => {
		if (!searchTerm) return onlyFavourites;
		if (searchTerm) return onlyFavourites.filter((exhibitor) => {
			const term = searchTerm.toLowerCase();
			return exhibitor['廠商名稱'].toLowerCase().includes(term) || exhibitor['攤位號碼'].toLowerCase().includes(term);
		});
	}, [onlyFavourites, searchTerm]);

	const toggleFavouriteExhibitor = useCallback((exhibitor) => {
		toggleFavourite(exhibitor);
	}, [toggleFavourite]);

	// 選的是「哪一家」（序號），攤位號碼只拿來標地圖——同號碼多家時才分得出點的是誰。
	const chooseExhibitor = (exhibitor, floor) => {
		appState.value = {
			...appState.value,
			ExhibitorInfo: true,
			activeFloor: floor !== undefined ? floor : appState.value.activeFloor,
			selectedBooth: exhibitor['攤位號碼'],
			selectedExhibitor: exhibitorKeyOf(exhibitor),
		};
	};

	const recordExhibitorClicked = useCallback((booth) => {
		makeRecord({
			Action: 'T',
			Booth: booth,
		});
	}, [makeRecord]);

	if (!MyFavourites) return null;

	return (
		<div id='MyFavourites' className={`ui-panel booth ${MyFavourites ? 'active' : ''}`}>
			<div className='panel-heading'>{translation('leftPanel.myFavorite')}</div>
			<div className='panel-body'>
				<div className='flex-controls'>
					<div className='search'>
						<input type='text' placeholder={translation('leftPanel.exhibitorList.search')} value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value) }} />
					</div>
				</div>

				<div className='exhibitors'>
					{filteredExhibitorInfo.map((exhibitor, index) => {
						const exhibitorName = exhibitor['廠商名稱'];
						const booth = exhibitor['攤位號碼'];

						return (
							<div className='exhibitor' key={`exhibitorLinkTableRow${index}`}>
								<div className='name' onClick={() => { chooseExhibitor(exhibitor, exhibitor.floor); recordExhibitorClicked(booth); }}>{exhibitorName}</div>
								<div className='booth-number' onClick={() => { chooseExhibitor(exhibitor, exhibitor.floor); recordExhibitorClicked(booth); }}>{booth}</div>
								<div className='icon' onClick={() => { toggleFavouriteExhibitor(exhibitor) }}>
									{exhibitor.favourite ? <IconHeartFilled /> : <IconHeart />}
								</div>
							</div>
						)
					})}
				</div>
			</div>

			<IconClose onClick={closePanel} />
		</div>
	)
}

export default MyFavourites;